import React, { useEffect, useState } from 'react';
import { Check, X, FileText, Package, Mail, Rocket, Star, Clock, AlertTriangle } from 'lucide-react';
import { Section, CTAButton } from './Shared';
const LaunchUrgency = () => {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 58,
    s: 9
  });
  const [spotsTaken, setSpotsTaken] = useState(() => {
    const saved = typeof window !== 'undefined' ? sessionStorage.getItem('reflexo-launch-spots') : null;
    if (saved) {
      const {
        value,
        timestamp
      } = JSON.parse(saved);
      const elapsed = (Date.now() - timestamp) / 1000;
      const increment = Math.floor(elapsed / 60);
      return Math.min(value + increment, 92);
    }
    return 68;
  });
  useEffect(() => {
    sessionStorage.setItem('reflexo-launch-spots', JSON.stringify({
      value: spotsTaken,
      timestamp: Date.now()
    }));
  }, [spotsTaken]);
  useEffect(() => {
    const id = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(id);
  }, []);
  useEffect(() => {
    const id = setInterval(() => {
      setSpotsTaken(prev => {
        if (prev >= 92) return prev;
        return Math.random() < 0.4 ? prev + 1 : prev;
      });
    }, 45000 + Math.random() * 30000);
    return () => clearInterval(id);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  const TimeBox = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-200">
      <div className="bg-brand-rose text-white font-mono font-bold text-2xl md:text-4xl rounded-xl px-3 md:px-5 py-2 md:py-3 min-w-[56px] md:min-w-[80px] text-center shadow-md tabular-nums" data-id="element-201">
        {fmt(value)}
      </div>
      <span className="text-[10px] md:text-xs font-medium text-brand-text/70 mt-1.5 uppercase tracking-wider" data-id="element-202">
        {label}
      </span>
    </div>;
  return <div className="max-w-4xl mx-auto mb-12" data-id="element-203">
      <div className="glass-panel rounded-3xl p-6 md:p-8 border-2 border-brand-rose/40 bg-gradient-to-br from-white/90 to-brand-rose/5 shadow-[0_10px_40px_rgba(212,115,140,0.15)]" data-id="element-204">
        {/* Header */}
        <div className="flex items-center justify-center gap-2 mb-5" data-id="element-205">
          <Clock className="w-5 h-5 md:w-6 md:h-6 text-brand-rose shrink-0" data-id="element-206" />
          <h3 className="font-serif font-bold text-base md:text-xl text-brand-text text-center" data-id="element-207">
            PRECIO DE LANZAMIENTO — CIERRA EN:
          </h3>
        </div>

        {/* Countdown */}
        <div className="flex items-center justify-center gap-2 md:gap-4 mb-5" data-id="element-208">
          <TimeBox value={timeLeft.h} label="Horas" data-id="element-209" />
          <span className="text-2xl md:text-4xl font-bold text-brand-rose/60 pb-5" data-id="element-210">
            :
          </span>
          <TimeBox value={timeLeft.m} label="Min" data-id="element-211" />
          <span className="text-2xl md:text-4xl font-bold text-brand-rose/60 pb-5" data-id="element-212">
            :
          </span>
          <TimeBox value={timeLeft.s} label="Seg" data-id="element-213" />
        </div>

        {/* Warning */}
        <div className="flex items-center justify-center gap-2 bg-yellow-50 border border-yellow-300/60 rounded-xl px-4 py-3 mb-6" data-id="element-214">
          <AlertTriangle className="w-4 h-4 md:w-5 md:h-5 text-yellow-600 shrink-0" data-id="element-215" />
          <p className="text-sm md:text-base font-semibold text-yellow-900 text-center" data-id="element-216">
            Después sube $10.000 ARS.{' '}
            <span className="text-brand-rose" data-id="element-217">No vuelve.</span>
          </p>
        </div>

        {/* Spots */}
        <div className="bg-white/70 rounded-2xl p-4 md:p-5 border border-brand-pink/30" data-id="element-218">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 mb-3" data-id="element-219">
            <div className="flex items-center gap-2" data-id="element-220">
              <span className="relative flex h-2.5 w-2.5" data-id="element-221">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" data-id="element-222"></span>
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500" data-id="element-223"></span>
              </span>
              <span className="font-semibold text-sm md:text-base text-brand-text" data-id="element-224">
                Cupos al precio de lanzamiento
              </span>
            </div>
            <span className="text-xs md:text-sm font-bold text-brand-rose uppercase tracking-wide" data-id="element-225">
              Quedan pocos
            </span>
          </div>

          <div className="w-full bg-brand-pink/15 rounded-full h-2.5 overflow-hidden mb-2" data-id="element-226">
            <div className="bg-gradient-to-r from-brand-rose to-red-500 h-2.5 rounded-full transition-all duration-1000 ease-out" style={{
            width: `${spotsTaken}%`
          }} data-id="element-227" />
          </div>

          <p className="text-xs md:text-sm text-brand-text/70 text-center" data-id="element-228">
            <strong className="text-brand-rose" data-id="element-229">{spotsTaken}%</strong> de los
            cupos al precio de lanzamiento ya tomados
          </p>
        </div>
      </div>
    </div>;
};
const REFLEXO_HREF = 'https://www.lumenakasha.com/cart/46722804678845:1';
const ACELERADOR_HREF = 'https://www.lumenakasha.com/cart/46787506733245:1';
const bonuses = [{
  icon: FileText,
  title: 'BONUS 1 — EL LEGAJO DE CAMPO',
  pages: '30 páginas · listo para imprimir',
  desc: 'Ficha de ingreso, registro de sesiones, evolución, zonas trabajadas y alta terapéutica. Nunca más le preguntás a un paciente cómo se sentía la vez anterior.',
  result: '✅ Tu legajo clínico completo desde el primer día'
}, {
  icon: Package,
  title: 'BONUS 2 — EL CONTROL DE ABASTECIMIENTO',
  pages: '30 páginas · listo para imprimir',
  desc: 'Auditoría, lista de insumos, control semanal, proveedores y gastos. Tu gabinete siempre listo antes de que empiece la jornada.',
  result: '✅ Nunca más te falta nada en plena jornada'
}, {
  icon: Mail,
  title: 'BONUS 3 — PACK DE TARJETAS POST-SESIÓN',
  pages: '30 páginas · listo para imprimir',
  desc: 'Tarjetas profesionales para entregar a tus pacientes al finalizar cada sesión. Indicaciones claras, seguimiento concreto y una imagen de alto nivel que el paciente recuerda y valora.',
  result: '✅ Cerrá cada sesión con más profesionalismo y cuidado'
}];
const plan1Items = [{
  name: 'Tomo Principal REFLEXO-PRO',
  value: '$40.000 ARS'
}, {
  name: 'Bonus 1: El Legajo de Campo',
  value: '$12.000 ARS'
}, {
  name: 'Bonus 2: El Control de Abastecimiento',
  value: '$10.000 ARS'
}, {
  name: 'Bonus 3: Pack de Tarjetas Post-Sesión',
  value: '$8.000 ARS'
}];
const plan2Items = [...plan1Items, {
  name: 'Acelerador de Consultorio',
  value: '$15.000 ARS'
}];
const aceleradorFeatures = ['Paquetes de 4, 8 y 12 sesiones que el paciente quiere comprar', 'Protocolo de Cierre en Camilla: el próximo turno reservado antes de que se vaya', 'Guiones de WhatsApp listos: recuperá pacientes y vendé sin incomodidad', 'Cómo subir precios sin perder pacientes', 'Instagram que atrae pacientes de calidad', 'Alianzas con otros profesionales de salud', 'Calculadora de rentabilidad incluida'];
const ValueTable = ({
  items,
  total,
  price
}: {
  items: {
    name: string;
    value: string;
  }[];
  total: string;
  price: string;
}) => <div className="rounded-2xl overflow-hidden border border-brand-pink/30 bg-white/70 mb-6" data-id="element-230">
    <div className="p-4 md:p-5 space-y-3" data-id="element-231">
      {items.map((item, i) => <div key={i} className="flex justify-between items-center gap-4 border-b border-brand-pink/15 pb-3 last:border-0 last:pb-0" data-id="element-232">
          <span className="text-brand-text/90 font-medium text-xs md:text-sm" data-id="element-233">
            {item.name}
          </span>
          <span className="text-brand-text/60 line-through text-xs md:text-sm whitespace-nowrap" data-id="element-234">
            {item.value}
          </span>
        </div>)}
    </div>
    <div className="bg-brand-surfaceLight/50 p-4 md:p-5 border-t border-brand-pink/30 space-y-2" data-id="element-235">
      <div className="flex justify-between items-center gap-4" data-id="element-236">
        <span className="font-serif font-bold text-sm md:text-base text-brand-text" data-id="element-237">
          Valor total
        </span>
        <span className="font-serif font-bold text-sm md:text-base text-brand-text/60 line-through whitespace-nowrap" data-id="element-238">
          {total}
        </span>
      </div>
      <div className="flex justify-between items-center gap-4" data-id="element-239">
        <span className="font-serif font-bold text-base md:text-lg text-brand-rose" data-id="element-240">
          Tu inversión hoy
        </span>
        <span className="font-serif font-bold text-xl md:text-2xl text-brand-rose whitespace-nowrap" data-id="element-241">
          {price}
        </span>
      </div>
    </div>
  </div>;
export const MethodOverview = () => {
  return <Section id="method" data-id="element-242">
      <div className="text-center mb-12" data-id="element-243">
        <div className="inline-flex items-center space-x-2 bg-white border border-brand-rose/30 px-4 py-1.5 rounded-full mb-6 shadow-sm" data-id="element-244">
          <span className="text-xl" data-id="element-245">🏆</span>
          <span className="font-serif font-semibold tracking-wider text-brand-rose text-sm md:text-base" data-id="element-246">
            KIT REFLEXO-PRO™
          </span>
        </div>
        <h2 className="text-2xl md:text-5xl font-serif font-bold mb-4 leading-tight" data-id="element-247">
          Elegí el plan que más te representa
        </h2>
      </div>

      {/* Shared content: Tomo + Bonuses preview */}
      <div className="max-w-4xl mx-auto mb-16" data-id="element-248">
        <div className="rounded-2xl p-6 md:p-8 border bg-[#FFF5F5] border-brand-pink/30 backdrop-blur-sm shadow-sm mb-6" data-id="element-249">
          <div className="flex flex-col md:flex-row md:items-start gap-4" data-id="element-250">
            <div className="text-4xl shrink-0" data-id="element-251">📘</div>
            <div className="flex-grow" data-id="element-252">
              <h4 className="font-serif font-bold mb-2 text-lg text-brand-rose" data-id="element-253">
                TOMO PRINCIPAL — REFLEXO-PRO
              </h4>
              <p className="text-brand-text/90 font-medium mb-2 text-base" data-id="element-254">
                Sistema de Gestión Clínica Profesional · 50 páginas
              </p>
              <p className="text-brand-text/80 text-sm mb-4" data-id="element-255">
                El manual completo para organizar, estructurar y profesionalizar
                tu trabajo como terapeuta en reflexología.
              </p>
              <div className="bg-white/50 p-3 rounded-lg border border-brand-pink/20 text-xs text-brand-text/70" data-id="element-256">
                ✅ 100% orientado al terapeuta argentino
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mb-8" data-id="element-257">
          <h3 className="text-xl md:text-2xl font-serif font-bold" data-id="element-258">
            🎁 3 BONUS INCLUIDOS
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-259">
          {bonuses.map((bonus, i) => {
          const Icon = bonus.icon;
          return <div key={i} className="glass-panel rounded-2xl p-5 border-brand-rose/30 relative overflow-hidden bg-white/80 flex flex-col" data-id="element-260">
                <div className="absolute top-0 right-0 bg-brand-rose text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-261">
                  GRATIS
                </div>
                <Icon className="w-7 h-7 text-brand-rose mb-3" data-id="element-262" />
                <h4 className="text-base md:text-lg font-serif font-bold mb-2 pr-14 leading-tight" data-id="element-263">
                  {bonus.title}
                </h4>
                <p className="text-brand-rose/90 text-xs font-medium mb-3" data-id="element-264">
                  {bonus.pages}
                </p>
                <p className="text-brand-text/80 mb-3 text-xs md:text-sm flex-grow" data-id="element-265">
                  {bonus.desc}
                </p>
                <div className="text-xs font-medium text-brand-green mt-auto" data-id="element-266">
                  {bonus.result}
                </div>
              </div>;
        })}
        </div>
      </div>

      {/* Launch urgency banner */}
      <LaunchUrgency data-id="element-267" />

      {/* The two plans */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 max-w-6xl mx-auto" data-id="element-268">
        {/* Plan 1 */}
        <div id="plan-1" className="glass-panel rounded-3xl p-6 md:p-8 border-brand-pink/40 bg-white/80 flex flex-col scroll-mt-24" data-id="element-269">
          <div className="mb-4" data-id="element-270">
            <div className="inline-flex items-center bg-brand-surfaceLight/60 border border-brand-pink/30 px-3 py-1 rounded-full text-xs font-semibold text-brand-text/80 mb-3" data-id="element-271">
              PLAN 1
            </div>
            <h3 className="text-2xl md:text-3xl font-serif font-bold mb-2 text-brand-text" data-id="element-272">
              KIT REFLEXO-PRO
            </h3>
            <p className="text-brand-text/80 text-sm md:text-base" data-id="element-273">
              Para la terapeuta que quiere organizar su gabinete y documentar su
              trabajo de forma profesional.
            </p>
          </div>

          <div className="bg-brand-surfaceLight/40 rounded-xl p-4 mb-6 border border-brand-pink/20" data-id="element-274">
            <p className="text-sm font-semibold text-brand-text mb-2" data-id="element-275">
              Incluye:
            </p>
            <ul className="space-y-1.5 text-sm text-brand-text/80" data-id="element-276">
              <li className="flex items-start" data-id="element-277">
                <Check className="w-4 h-4 text-brand-green mr-2 mt-0.5 shrink-0" data-id="element-278" />
                Tomo Principal REFLEXO-PRO (50 pág)
              </li>
              <li className="flex items-start" data-id="element-279">
                <Check className="w-4 h-4 text-brand-green mr-2 mt-0.5 shrink-0" data-id="element-280" />
                Bonus 1, 2 y 3 (90 pág en total)
              </li>
              <li className="flex items-start" data-id="element-281">
                <Check className="w-4 h-4 text-brand-green mr-2 mt-0.5 shrink-0" data-id="element-282" />
                140 páginas listas para imprimir
              </li>
            </ul>
          </div>

          <ValueTable items={plan1Items} total="$70.000 ARS" price="$19.990 ARS" data-id="element-283" />

          <div className="mt-auto" data-id="element-284">
            <CTAButton fullWidth className="text-sm md:text-base py-4" href="#pricing" data-id="element-285">
              🦶 → QUIERO EL KIT REFLEXO-PRO POR $19.990
            </CTAButton>
          </div>
        </div>

        {/* Plan 2 — featured */}
        <div className="glass-panel rounded-3xl p-6 md:p-8 border-2 border-brand-rose bg-white/90 flex flex-col relative shadow-[0_0_0_4px_rgba(244,194,210,0.35),0_0_24px_4px_rgba(232,140,167,0.45),0_10px_40px_rgba(212,115,140,0.25)] animate-glow-pulse" data-id="element-286">
          <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-rose text-white text-xs font-bold px-4 py-1.5 rounded-full whitespace-nowrap flex items-center gap-1" data-id="element-287">
            <Star className="w-3.5 h-3.5 fill-current" data-id="element-288" />
            MÁS ELEGIDO
          </div>

          <div className="mb-4 mt-2" data-id="element-289">
            <div className="inline-flex items-center bg-brand-rose/10 border border-brand-rose/30 px-3 py-1 rounded-full text-xs font-semibold text-brand-rose mb-3" data-id="element-290">
              ⭐ PLAN 2
            </div>
            <h3 className="text-2xl md:text-3xl font-serif font-bold mb-2 text-brand-text" data-id="element-291">
              KIT ACELERADOR
            </h3>
            <p className="text-brand-text/80 text-sm md:text-base" data-id="element-292">
              Para la terapeuta que quiere organizar su gabinete Y vivir bien de
              su profesión.
            </p>
          </div>

          <div className="bg-brand-rose/5 rounded-xl p-4 mb-4 border border-brand-rose/30" data-id="element-293">
            <p className="text-sm font-semibold text-brand-text mb-2" data-id="element-294">
              Todo lo incluido en el Kit Reflexo-PRO, más:
            </p>
            <div className="flex items-start gap-3 mb-3" data-id="element-295">
              <Rocket className="w-6 h-6 text-brand-rose shrink-0 mt-0.5" data-id="element-296" />
              <div data-id="element-297">
                <h4 className="font-serif font-bold text-base text-brand-rose" data-id="element-298">
                  ACELERADOR DE CONSULTORIO
                </h4>
                <p className="text-xs text-brand-text/70" data-id="element-299">
                  45 páginas · rentabilidad y fidelización
                </p>
              </div>
            </div>
            <p className="text-sm text-brand-text/80 italic mb-3" data-id="element-300">
              El sistema para dejar de depender de la sesión suelta y construir
              un consultorio con ingresos predecibles.
            </p>
            <ul className="space-y-2 text-xs md:text-sm text-brand-text/80" data-id="element-301">
              {aceleradorFeatures.map((feat, i) => <li key={i} className="flex items-start" data-id="element-302">
                  <Check className="w-4 h-4 text-brand-green mr-2 mt-0.5 shrink-0" data-id="element-303" />
                  <span data-id="element-304">{feat}</span>
                </li>)}
            </ul>
          </div>

          <p className="text-sm font-medium text-brand-rose italic text-center mb-5" data-id="element-305">
            Una sola sesión recuperada con esta guía ya paga la diferencia de
            precio.
          </p>

          <ValueTable items={plan2Items} total="$85.000 ARS" price="$27.990 ARS" data-id="element-306" />

          <div className="mt-auto" data-id="element-307">
            <CTAButton fullWidth className="text-sm md:text-base py-4 animate-pulse-slow" href="#pricing" data-id="element-308">
              ⭐ → QUIERO EL KIT ACELERADOR POR $27.990
            </CTAButton>
          </div>
        </div>
      </div>
    </Section>;
};